import { JobQueue } from "./jobQueue";

export const jobQueuesInitialState: JobQueueState = Object.freeze({
  isLoading: true,
  queues: {},
  showAddQueueModal: false,
  showDeleteQueueModal: false,
});

export interface JobQueueState {
  queues: { [key: number] : JobQueue };
  isLoading: boolean;
  showAddQueueModal: boolean;
  showDeleteQueueModal: boolean;
  deleteJobQueue?: JobQueue;
  updateJobQueue?: JobQueue;
}